import script from "./WifiListTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./WifiListTable.vue?vue&type=script&setup=true&lang=ts"

import "./WifiListTable.vue?vue&type=style&index=0&id=8fa8977a&lang=css"

const __exports__ = script;

export default __exports__